import { ReactNode } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'

import { MobileHeader, Header, FABScan } from 'src/components'

interface IProps {
  children: ReactNode
  headerTitle?: string | ReactNode
  headerDescr?: string
  headerCode?: string
  navigateBack?: boolean
  navigateBackRoute?: string | null
  withAccountIcon?: boolean
  withScanBtn?: boolean
  doNotShowCodeOnMobile?: boolean
}

const MainContainer = ({
  children,
  headerTitle,
  headerDescr,
  headerCode,
  navigateBack,
  navigateBackRoute,
  withAccountIcon,
  withScanBtn,
  doNotShowCodeOnMobile,
}: IProps) => {
  const theme = useTheme()
  const isLaptop = useMediaQuery(theme.breakpoints.down('laptop'))

  return (
    <>
      {isLaptop ? (
        <MobileHeader
          headerDescr={headerDescr}
          headerCode={headerCode}
          headerTitle={headerTitle}
          doNotShowCodeOnMobile={doNotShowCodeOnMobile}
          navigateBack={navigateBack}
          navigateBackRoute={navigateBackRoute}
        />
      ) : (
        <Header withAccountIcon={!!withAccountIcon} title={headerTitle} />
      )}

      {children}
      {withScanBtn && <FABScan />}
    </>
  )
}

export { MainContainer }
